export const breakpointValues = {
  mobile: 0, // 0px to 600px
  tablet: 600, // 600px to 960px
  laptop: 960, // 960px to 1280px
  desktop: 1280, // 1280px to 2000px
  largeDesktop: 2000, // 200px to 3000px
  xl: 3000, // over 3000px
} as const

export const tabletUp = `@media (min-width:${breakpointValues.tablet}px)`
export const laptopUp = `@media (min-width:${breakpointValues.laptop}px)`
export const desktopUp = `@media (min-width:${breakpointValues.desktop}px)`
